<form (ngSubmit)="onSubmit()">
  <ngf-input-container class="navigation-header__search">
    <span ngfPrefix>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M17.5 17.5L12.5001 12.5M14.1667 8.33333C14.1667 11.555 11.555 14.1667 8.33333 14.1667C5.11167 14.1667 2.5 11.555 2.5 8.33333C2.5 5.11167 5.11167 2.5 8.33333 2.5C11.555 2.5 14.1667 5.11167 14.1667 8.33333Z" stroke="#A4A7AE" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
    <input
      type="text"
      name="search"
      placeholder="Search"
      [(ngModel)]="query" />
  </ngf-input-container>
</form>
